import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { Userpilot } from 'userpilot';
import '@/index.css';
import { initSentry } from 'analytics/sentry';
import { loadHubspotCMP } from 'analytics/hubspot';
import {
  initUserpilotIfAllowed,
  watchUserpilotConsentChanges,
} from 'analytics/userpilot';
import { HelmetProvider } from 'react-helmet-async';

initSentry();
loadHubspotCMP();
initUserpilotIfAllowed();
watchUserpilotConsentChanges();

if (import.meta.env.VITE_USERPILOT_TOKEN) {
  Userpilot.initialize(import.meta.env.VITE_USERPILOT_TOKEN);
}

const rootElement = document.getElementById('root')!;

createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
